var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',[_c('a-input',{staticClass:"provisioning_agree_container",attrs:{"type":"textarea","defaultValue":_vm.termsContent,"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }